import { toast } from "sonner"

import { Sparkles, X } from "@/components/icons"
import { Button } from "@/components/ui/button"
import i18n from "@/languageConfig"
import { cn } from "@/lib/utils"

const TOAST_ID = "deep-mode-on"

export function showDeepModeOnToast(options?: { onTurnOff?: () => void }) {
  toast.custom(
    (id) => (
      <div
        data-testid="deep-mode-on-toast"
        role="status"
        className={cn(
          "bg-background text-foreground border-border relative w-[360px] overflow-hidden rounded-lg border shadow-lg",
          "ring-primary/15 ring-1"
        )}
      >
        <div className="from-primary/40 via-primary/15 absolute inset-x-0 top-0 h-px bg-gradient-to-r to-transparent" />
        <div className="flex items-start gap-3 p-3.5">
          <div
            aria-hidden
            className={cn(
              "from-primary/15 to-primary/5 ring-primary/20 grid size-9 shrink-0 place-items-center rounded-full bg-gradient-to-br ring-1",
              "motion-safe:animate-[pulse_2.4s_ease-in-out_2]"
            )}
          >
            <Sparkles className="text-primary size-4" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-foreground font-display text-[15px] leading-tight">
              {i18n.t("deepExplorer.deep_mode_on_toast.title")}
            </p>
            <p className="text-muted-foreground mt-0.5 text-[13px] leading-snug">
              {i18n.t("deepExplorer.deep_mode_on_toast.description")}
            </p>
            {options?.onTurnOff ? (
              <button
                className="text-primary hover:text-primary/80 focus-visible:ring-ring mt-2 -ml-0.5 rounded px-0.5 text-[12px] font-medium underline-offset-2 hover:underline focus-visible:ring-2 focus-visible:outline-none"
                type="button"
                onClick={() => {
                  options.onTurnOff?.()
                  toast.dismiss(id)
                }}
              >
                {i18n.t("deepExplorer.deep_mode_on_toast.turn_off")}
              </button>
            ) : null}
          </div>
          <Button
            aria-label={i18n.t("deepExplorer.deep_mode_on_toast.dismiss_aria")}
            className="text-muted-foreground hover:text-foreground -mt-0.5 -mr-0.5 size-8 shrink-0"
            size="icon"
            variant="ghost"
            onClick={() => toast.dismiss(id)}
          >
            <X className="size-4" />
          </Button>
        </div>
      </div>
    ),
    {
      id: TOAST_ID,
      duration: 4500,
    }
  )
}
